<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 稽查管理  
        </el-breadcrumb-item>
        <el-breadcrumb-item>稽查记录查询</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="产品编码" prop="productCode">
                <el-select
                  v-model="searchform.productCode"
                  placeholder="请输入产品名称模糊匹配或者下拉选择"
                  style="width:100%"
                  :remote-method="getproductlist"
                  filterable
                  remote
                  :loading="productloading"
                  :disabled="show"
                >
                  <el-option
                    v-for="item in productlist"
                    :key="item.product_code"
                    :label="item.product"
                    :value="item.product_code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产批次" prop="batchno" >
                <el-input v-model="searchform.batchno" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="稽查人员" prop="accountName" >
                <el-input v-model="searchform.accountName" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="稽查时间" prop="datelist" >
                    <el-date-picker
                           style="width:100%"
                           v-model="searchform.datelist"
                           type="daterange"
                           value-format="yyyy-MM-dd HH:mm:ss"
                           range-separator="-"
                           start-placeholder="开始日期"
                           end-placeholder="结束日期">
                   </el-date-picker>
              </el-form-item>
            </el-col>     
          </el-row>
                      <el-row>
            <el-col :span="8" :offset="1"> 
               <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search" v-permission="['inspectrecord_select']">搜索</el-button>
               <el-button
              v-permission="['inspectrecord_export']"
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
              >导出Excel</el-button>
            </el-col>
            </el-row> 
        </el-form>
      </div>
<br>
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>稽查记录流水</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
           <el-table-column prop="employeeName" label="稽查人员" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="packageLevel" label="包装级别" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="product" label="产品" min-width="250" show-overflow-tooltip></el-table-column>
            <el-table-column prop="batchno" label="生产批次" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="qrcode" label="码" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dealerCode" label="经销商编码" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dealerName" label="经销商名称" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="freightBillCode" label="出库单号" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="freightBillCodeTime" label="出库时间" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="province" label="发货到达区域" min-width="160" show-overflow-tooltip></el-table-column>           
            <el-table-column prop="createTime" label="稽查时间" min-width="160" show-overflow-tooltip></el-table-column>            
            <el-table-column prop="queryprovince" label="稽查扫码区域" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="memo" label="系统判断" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="manualMemo" label="人工判断" min-width="120" show-overflow-tooltip></el-table-column>
            
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { selectins } from "@/api/physical";
import { productlist } from "@/api/base";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.Tabledata();
    this.getproductlist();
  },
  data() {
    return {
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
        //产品列表下拉
      productloading: false,
      show: false,
      productlist: [], 
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
       //导出表格变量
      tableDataDownload: [],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //搜索表单数据

      searchform: {
        accountName:null,
        batchno: null,
        datelist:[],
        screateTime: null,
        ecreateTime:null,
        productCode: null,
        currPage:1,
        pageSize:10
      }
    };
  },
  methods: {
     // 获取产品下拉
     getproductlist(value) {
      this.productlist = [];
      if (value !== "") {
        this.productloading = true;
        setTimeout(() => {
          this.productloading = false;
          productlist({ productName: value }).then(response => {
            this.productlist = response.data.data;
            for (var i = 0; i < this.productlist.length; i++) {
              this.productlist[i].product =
                this.productlist[i].product_code +
                "   " +
                this.productlist[i].product_name;
            }
          });
        }, 200);
      } else {
        this.productlist = [];
      }
    },
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      selectins(obj).then(response => {
        this.packdate(response.data.list)
        this.tableData = response.data.list;
        this.total_count = response.data.totalCount;
        this.currentPage = response.data.currPage;
        this.listLoading = false;
        console.log(this.tableData)
      });
    },
    packdate(obj){
      for (let i = 0; i < obj.length; i++) {
         obj[i].province = (obj[i].provinceCodeSell ||" ") + (obj[i].cityCodeSell || " ")
         obj[i].queryprovince = (obj[i].provinceCodeScan||" ") + (obj[i].cityCodeScan || " ")
         obj[i].product = (obj[i].productCode||" ") + (obj[i].productName || " ")
          switch (obj[i].packageLevel) {
             case 1:obj[i].packageLevel = "盒码"              
                 break;
                 case 2:obj[i].packageLevel = "箱码"                
                 break;       
             default:
                 break;
         }
        }
    },
    
    //搜索事件
    search() {
        this.Tabledata({
          accountName:this.searchform.accountName,
        productCode: this.searchform.productCode,
        screateTime: this.searchform.datelist==null ? null:this.searchform.datelist[0],
        ecreateTime: this.searchform.datelist==null ? null:this.searchform.datelist[1],
        batchno:this.searchform.batchno,
       
        pageSize:this.searchform.pageSize
        });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage
       this.Tabledata({
          accountName:this.searchform.accountName,
        productCode: this.searchform.productCode,
        screateTime: this.searchform.datelist==null ? null:this.searchform.datelist[0],
        ecreateTime: this.searchform.datelist==null ? null:this.searchform.datelist[1],
        batchno:this.searchform.batchno,
        currPage:this.searchform.currPage,
        pageSize:this.searchform.pageSize
        });
      console.log(currPage)
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize
      this.search()
    },
                  //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        page_index: 1,
        pageSize: this.total_count,
         accountName:this.searchform.accountName,
        productCode: this.searchform.productCode,
        screateTime: this.searchform.datelist==null ? null:this.searchform.datelist[0],
        ecreateTime: this.searchform.datelist==null ? null:this.searchform.datelist[1],
        batchno:this.searchform.batchno,
      };
      selectins(obj).then(response => {
        this.packdate(response.data.list)
        this.tableDataDownload = response.data.list;

        console.log(this.tableDataDownload);
        import("@/vendor/Export2Excel").then(excel => {
          const tHeader = [
            "稽查人员",
            "包装级别",
            "产品",
            "生产批次",
            "码",
            "经销商编码",
            "经销商名称",
            "出库单号",
            "出库时间",
            
            "发货到达区域",
            "稽查时间",
            "稽查扫码区域",
            "系统判断",
            "人工判断"
          ];
          const filterVal = [
            "employeeName",
            "packageLevel",
            "product",
            "batchno",
            "qrcode",
            "dealerCode",
            "dealerName",
            "freightBillCode",
            "freightBillCodeTime",
            "province",
            "createTime",
            "queryprovince",
            "memo",
            "manualMemo"

          ];
          const list = this.tableDataDownload;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          this.downloadLoading = false;
        });
      }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 10px 0;
}
.border {
  padding: 10px 10px;
  border-radius: 3px;
  border: 1px solid #e6ebf5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
}
.handle-box {
  margin-bottom: 0px;
}
.handle-input {
  width: 160px;
  display: inline-block;
}
.del-dialog-cnt {
  font-size: 16px;
  text-align: center;
}
.mr10 {
  margin-right: 10px;
}
#parent {
  text-align: center;
}
</style>